import React, { useState, useEffect } from "react";

// Helper to get VideoSDK token from env
const VIDEO_TOKEN = process.env.REACT_APP_VIDEO_TOKEN;
const API_URL = "https://api.videosdk.live/v2/rooms";

// Fetch all rooms
async function fetchRooms(token) {

  console.log("token", token.charAt(0));

  const res = await fetch(API_URL, {
    method: "GET",
    headers: {
      Authorization: token,
      "Content-Type": "application/json",
    },
  });
  if (!res.ok) {
    console.log("error", res);
    throw new Error("Failed to fetch rooms");
  }
  console.log("res", res);
  return res.json();
}

// Create a new room
async function createRoom(token) {
  const res = await fetch(API_URL, {
    method: "POST",
    headers: {
      Authorization: token,
      "Content-Type": "application/json",
    },
  });
  if (!res.ok) throw new Error("Failed to create room");
  const data = await res.json();
  return data.roomId;
}

const RoomManager = ({ onJoin }) => {
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [creating, setCreating] = useState(false);
  const [joiningRoomId, setJoiningRoomId] = useState(null);

  // Fetch rooms on mount and on refresh
  const loadRooms = async () => {
    setLoading(true);
    setError("");
    try {
      const data = await fetchRooms(VIDEO_TOKEN);
      console.log("data", data);
      setRooms(data.data || []);
    } catch (err) {
      setError("Could not fetch rooms: " + err.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadRooms();
  }, []);

  // Create a new room
  const handleCreateRoom = async () => {
    setCreating(true);
    setError("");
    try {
      const newRoomId = await createRoom(VIDEO_TOKEN);
      setRooms((prev) => [{ roomId: newRoomId, participants: [] }, ...prev]);
    } catch (err) {
      setError("Could not create room: " + err.message);
    }
    setCreating(false);
  };

  // Join a room
  const handleJoinRoom = (roomId) => {
    if (joiningRoomId) {
      console.log("Already joining a room, ignoring duplicate join for", roomId);
      return;
    }
    console.log("Joining room", roomId);
    setJoiningRoomId(roomId);
    onJoin({ roomId, token: VIDEO_TOKEN });
  };

  // UI
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #232526 0%, #414345 100%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 0',
    }}>
      <div style={{
        background: 'rgba(255,255,255,0.07)',
        borderRadius: 24,
        boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
        padding: 36,
        width: 420,
        maxWidth: '90vw',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}>
        <h2 style={{ color: '#fff', fontWeight: 700, marginBottom: 16, letterSpacing: 1 }}>Join a Room</h2>
        <div style={{ display: 'flex', gap: 12, marginBottom: 28 }}>
          <button
            onClick={handleCreateRoom}
            disabled={creating}
            style={{
              background: 'linear-gradient(90deg, #ff8a00 0%, #e52e71 100%)',
              color: '#fff',
              border: 'none',
              borderRadius: 12,
              padding: '12px 32px',
              fontSize: 18,
              fontWeight: 600,
              cursor: creating ? 'not-allowed' : 'pointer',
              boxShadow: '0 2px 8px rgba(229,46,113,0.15)',
              transition: 'background 0.2s',
            }}
          >
            {creating ? 'Creating...' : 'Create New Room'}
          </button>
          <button
            onClick={loadRooms}
            disabled={loading}
            style={{
              background: 'linear-gradient(90deg, #43cea2 0%, #185a9d 100%)',
              color: '#fff',
              border: 'none',
              borderRadius: 12,
              padding: '12px 32px',
              fontSize: 18,
              fontWeight: 600,
              cursor: loading ? 'not-allowed' : 'pointer',
              boxShadow: '0 2px 8px rgba(24,90,157,0.15)',
              transition: 'background 0.2s',
            }}
          >
            {loading ? 'Refreshing...' : 'Refresh Rooms'}
          </button>
        </div>
        {loading ? (
          <div style={{ color: '#fff', margin: '32px 0' }}>Loading rooms...</div>
        ) : error ? (
          <div style={{ color: '#ff4d4f', margin: '32px 0' }}>{error}</div>
        ) : rooms.length === 0 ? (
          <div style={{ color: '#fff', margin: '32px 0' }}>No rooms available. Create one!</div>
        ) : (
          <div style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 18,
            maxHeight: 340,
            overflowY: 'auto',
            paddingRight: 4,
            scrollbarWidth: 'thin',
            scrollbarColor: '#ff8a00 #232526',
          }}>
            {rooms.map((room) => {
              const participantCount = room.participants ? room.participants.length : 0;
              const isFull = participantCount >= 2;
              return (
                <div
                  key={room.roomId}
                  style={{
                    background: 'rgba(255,255,255,0.13)',
                    borderRadius: 14,
                    padding: '18px 20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                  }}
                >
                  <div style={{ color: '#fff', fontWeight: 500, fontSize: 17 }}>
                    Room <span style={{ color: '#ff8a00' }}>{room.roomId.slice(-6)}</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <span style={{ color: isFull ? '#ff4d4f' : '#00e676', fontWeight: 600 }}>
                      {participantCount}/2
                    </span>
                    <button
                      onClick={() => handleJoinRoom(room.roomId)}
                      disabled={isFull || joiningRoomId === room.roomId}
                      style={{
                        background: isFull ? '#aaa' : 'linear-gradient(90deg, #43cea2 0%, #185a9d 100%)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: 8,
                        padding: '8px 22px',
                        fontSize: 16,
                        fontWeight: 600,
                        cursor: isFull ? 'not-allowed' : 'pointer',
                        opacity: joiningRoomId === room.roomId ? 0.7 : 1,
                        transition: 'background 0.2s',
                      }}
                    >
                      {isFull ? 'Full' : joiningRoomId === room.roomId ? 'Joining...' : 'Join'}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
     
    </div>
  );
};

export default RoomManager; 